import React from "react";

export default class ProfileImage extends React.Component {
  render() {
    return (
      <img
        src={"https://i.postimg.cc/qMM74xFH/profile-photo.jpg"}
        alt="Avatar"
        className="profileImage"
      />
    );
  }
}
